import { render, staticRenderFns } from "./cashBox.vue?vue&type=template&id=68b10e03&scoped=true&"
import script from "./cashBox.vue?vue&type=script&lang=js&"
export * from "./cashBox.vue?vue&type=script&lang=js&"
import style0 from "./cashBox.vue?vue&type=style&index=0&id=68b10e03&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b10e03",
  null
  
)

export default component.exports